import React from 'react'
import { Button } from '@/components/Button/Button'
import { LeftIcon } from '@/components/quiz/Icons'

export const Header = ({
  hidePrevButton,
  title,
  onPrevStep,
}: {
  hidePrevButton?: boolean
  title?: string
  onPrevStep?: () => void
}) => {
  return (
    <header className="py-4 text-center relative">
      {onPrevStep && !hidePrevButton && (
        <Button
          onClick={() => onPrevStep()}
          className="absolute top-1/2 -translate-y-1/2 left-0 w-10 h-10 p-0 border-none before:w-11 before:h-11 before:top-1/2 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:absolute"
        >
          <LeftIcon />
        </Button>
      )}
      <p className="text-base font-semibold leding-normal">{title ?? 'Clean Master'}</p>
    </header>
  )
}
